export const KEYFRAME = {
  CAN_CREATE_FROM_BOARD: 'users_can_create_from_board',
  REFESH_DELAY_VIEW_MODE: 'refresh_delay_view_mode',
  CALENDAR_COLUMN: 'calendar_default_columns',
  DAYS_DISPLAY: 'event_manager_default_days_displayed',
};
